import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../../hooks/useTheme.js';
import { Box } from '../../Box/index.js';
import { useResponsiveReact } from '../../Responsive/ResponsiveReact/useResponsiveReact.js';
import { useMainNavContext } from '../MainNavContext/index.js';

var MainNavHeader = forwardRef(function (_a, forwardedRef) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var themeKey = useMainNavContext().themeKey;
    var isMobile = useResponsiveReact({ max: "sm" });
    var forwardProps = handleStyleProps(props, {
        themeKey: "".concat(themeKey, "Header"),
    });
    return (jsx(Box, __assign({ as: isMobile ? "div" : "header", ref: forwardedRef, "data-main-nav-header": true }, forwardProps, { children: children })));
});
MainNavHeader.displayName = "MainNavHeader";

export { MainNavHeader };
//# sourceMappingURL=MainNavHeader.js.map
